import React, { useContext, useEffect, useRef, useState } from "react";
import { FaFileUpload, FaFileDownload} from "react-icons/fa";
import userImg from "../../assets/images/Others/userTest.jpeg";
import { RootContext } from "../../context/RootProvider";
import { changeCV } from "../../utils/apiCalls";
import style from "./ContentProfile.module.css";
import { API_URL } from "../../const";
import axios from "axios";
import {Toaster, toast} from "react-hot-toast";

function ContentProfile() {
  const rootContext = useContext(RootContext);
  const [user, setUser] = useState(null);
  const [interview, setInterview] = useState("");
  const [CV, setCV] = useState(null);
  const timeoutIDRef = useRef();

  const CVChangedMessage = CV
    ? `CV-ul a fost schimbat cu succes (${CV.name})`
    : "CV-ul trebuie sa existe. (CV-ul nu a fost schimbat)";

  useEffect(() => {
    setUser(rootContext.user);
    async function fetchInterview() {
      try{
        if (!rootContext.user?.InterviewId) {
          setInterview("");
          return;
        }
        const res = await axios.get(
          `${API_URL}/api/interview/${rootContext.user.InterviewId}`
        );
        const interviewDate = new Date(res.data.date);
        interviewDate.setHours(interviewDate.getHours());
        res.data.date = interviewDate;
        
        setInterview(res.data);
      }catch(err){
        console.log(err);
        setInterview("");
      }
    }
    fetchInterview();
  }, []);

  async function onChangeCV(CVData) {
    clearTimeout(timeoutIDRef.current);

    const userData = {
      cv: CVData,
      lastName: user?.lastName,
      firstName: user?.firstName,
      id: user?.id,
      InterviewId: user?.InterviewId,
    };
    if (CVData) {
      try {const rezultat = await changeCV(userData);
      setCV(CVData);
      toast.success(`CV-ul a fost schimbat cu succes`);}
      catch(err){
        console.log(err);
        toast.error(`CV-ul trebuie să fie în format PDF`);
      }
    }

    else {
      toast.error(`CV-ul trebuie sa existe. (CV-ul nu a fost schimbat)`);
    }
    
    timeoutIDRef.current = setTimeout(() => {
      setCV(null);
    }, 7500);
  }

  return (
    <>
    <div className={style.content}>
      <div className={style.profile}>
        <div className={style.profileTop}>
            <img className={style.profilePicture} src={userImg} alt="user-image" />
          <h2>
            <span>{user?.lastName}</span> <span>{user?.firstName}</span>
          </h2>
        </div>
        <div className={style.userInfo}>
          <p>
            <span>Universitate: </span> <span>{user?.university}</span>
          </p>
          <p>
            <span>Mail: </span> <span>{user?.email}</span>
          </p>
          <p>
            <span>Telefon: </span> <span>{user?.phoneNumber}</span>
          </p>
          <p>
            <span>Interviu:</span>{" "}
            <span>
              {interview == ""
                ? "Neprogramat!"
                : new Date(interview.date).toLocaleString("ro-RO", {
                    hour: "2-digit",
                    minute: "2-digit",
                    day: "numeric",
                    month: "long",
                    weekday: "long",
                  })}
            </span>
          </p>

          {/* buton schimbare cv-uri */}

          <div className={style.buttonZone}>
            { <div className={style.inputCV}>
              <input onChange={(e) => onChangeCV(e.target.files[0])} name="CV" id="CV" type="file" accept="application/pdf" />
              <label htmlFor="CV" className={`${style.align} ${style.btnCv}`}>
                <FaFileUpload fontSize={20} />
                <br />
                <p className={style.textButtons}>Schimbă CV-ul</p>
              </label>
            </div> }

            <div className={style.inputCV}>
              <a
                className={`${style.align} ${style.btnCv}`}
                href={`${API_URL}/api/user/cv/${user?.id}`}
                download
              >
                <FaFileDownload fontSize={20} />
                <p className={style.textButtons}>Descarcă CV-ul</p>
              </a>
            </div>
          </div>

              {/* info */}

          {/* <h3 className={style.important}>Testul tehnic durează maxim 30 de minute, poate fi dat o singură dată și trebuie dat până pe 17.03.2024.</h3> */}

          <p
            className={`${style.confirmCVMessage} ${
              CV !== null ? style.confirmCVActive : style.confirmCVChanged
            }`}
          >
            {CVChangedMessage}
          </p>
        </div>
      </div>
    </div>
    <Toaster/>
    </>
  );
}

export default ContentProfile;


